import React from 'react'
import { DoughnutChart } from '../../../app/models/charts';
import { KoUpReCycle } from '../../../app/models/dataErasure';
import KoReportingChart from '../koreporting/koReportingCharts/KoReportingChart';


interface RecycleProps {
    koUpReCycle: KoUpReCycle;
}

const getData = (chartval: number[], chartLabel: string[]) => {
    const data: DoughnutChart = {
        labels: chartLabel,
        datasets: [
            {
                label: "Units",
                data: chartval,
                backgroundColor: [                   
                    'rgb(237,125,49)',
                    'rgb(68,114,196)',
                ],
                borderColor: [
                    'rgb(68,114,196)',
                    'rgb(237,125,49)',
                ],
                borderWidth: 1,
            },
        ],
    };
    return data;
}


const KoUpReCyclePieChart = ({ koUpReCycle }: RecycleProps) => {
    return (
        // <Box sx={{ width: 400, Height: 400 }}>
        <KoReportingChart data={getData([koUpReCycle.reCycled, koUpReCycle.upCycle], ['Upcycle', 'Recycle'])} />
        // </Box>
    )
}

export default KoUpReCyclePieChart